"use client";

import { createContext, useContext, useState } from "react";

const TabContext = createContext();

export const TabProvider = ({ children, defaultTab = "search" }) => {
  const [activeTab, setActiveTab] = useState(defaultTab);

  const value = {
    activeTab,
    setActiveTab,
  };

  return <TabContext.Provider value={value}>{children}</TabContext.Provider>;
};

export const useTab = () => {
  const context = useContext(TabContext);
  if (context === undefined) {
    throw new Error("useTab must be used within a TabProvider");
  }
  return context;
};
